import React, { useEffect, useState } from "react";
import "./Admin.scss";
import AdminTable from "../../components/AdminTable/AdminTable";
import AdminTableFilterHeader from "../../components/AdminTableFilterHeader/AdminTableFilterHeader";
import AdminTableHeader from "../../components/AdminTableHeader/AdminTableHeader";
import PortalUserCreation from "../../components/PortalUserCreation/PortalUserCreation";
import { getPortalUsers } from "../../util/API/admin";
import { useSelector, useDispatch } from "react-redux";
import { setPortalUsers } from "../../store/redux/portalUsers";
import { getSystemStatus } from "../../util/API/admin";
import { Box } from "@mui/material";

function Admin() {
  const [open, setOpen] = useState(false);
  const [portalFilterList, setPortalFilterList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [updateUser, setUpdateUser] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [isViewOperators, setIsViewOperators] = useState(false); 

  const dispatch = useDispatch();
  // const portalList = useSelector((state) => state.portalUsers.portalUsers);
  const requiredConstants = useSelector((state) => state.constants);

const systemStatus = async() => {
  const response = await getSystemStatus();
  console.log(response);
}

const systemRoles = async () => {
  const allRoles = requiredConstants.systemRoles || [];
  console.log(JSON.stringify(allRoles))
  const transformedRoles = allRoles.filter(role => role.securityrole.name.toLowerCase() !== "ncs consumer" && role.securityrole.name.toLowerCase() !== "ncs operator" && role.securityrole.name.toLowerCase() !== "operator" && role.securityrole.name.toLowerCase() !== "external payroll admin" && role.securityrole.roleid !== "708").map(role => ({
    key: role.securityrole.roleid,
    value: role.securityrole.roleid,
    label: role.securityrole.name,
  }));
  console.log("Filtered roels ???????????", transformedRoles)
  setRoles(transformedRoles);
};

useEffect(() => {
  systemStatus();
  systemRoles();
}, []);

const portalUsers = async () => {
  const response = await getPortalUsers();
  console.log("portalUsers----------",response);
  const userList = response?.payload;
  if (Array.isArray(userList)) {
    setUsers(userList);
  } else if (userList) {
    setUsers([userList]);
  }
  else {
    setUsers([]);
  }

  if (userList.length) {
    dispatch(setPortalUsers(userList));
  } else {
    dispatch(setPortalUsers([userList]));
  }
};

console.log(users.length)

  useEffect(() => {
    portalUsers();
  }, [updateUser]);

  useEffect(() => {
    if (users) {
      let sortedUsers = [...users].sort((a, b) => b.Vuser.id - a.Vuser.id);
      setPortalFilterList(sortedUsers);
      if (searchText.trim() === "") {
        setPortalFilterList([...sortedUsers]);
      } else {
        const filtered = users.filter(
          (user) =>
            user.Vuser.firstName
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            user.Vuser.lastName
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            user.Vuser.emailAccount
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            user.Vuser.telephoneno.includes(searchText)
        );
        setPortalFilterList(filtered.sort((a, b) => b.Vuser.id - a.Vuser.id));
      }
    }
  }, [users, searchText]);

  return (
    <>
      <PortalUserCreation 
        open={open} 
        handleClose={handleClose} 
        roles={roles} 
        updateUser={updateUser}
        setUpdateUser={setUpdateUser}
        portalUsers={portalFilterList}
      />

      <Box className="page-container admin-container">
        <Box
          className="header-container"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box style={{ display: "flex" }}>
            <Box className="admin-header">Admin</Box>
            <Box className="admin-subtitle" style={{ marginLeft: 10 }}>
              User Management
            </Box>
          </Box>

          <AdminTableFilterHeader
            handleOpen={handleOpen}
            setSearchText={setSearchText}
            searchText={searchText}
          />
        </Box>

        <Box className="admin-table-container">
          {!isViewOperators && <AdminTableHeader portalFilterList={portalFilterList} />}
          <AdminTable
            portalFilterList={portalFilterList}
            updateUser={updateUser}
            setUpdateUser={setUpdateUser}
            portalUsers={portalUsers}
            systemRoles={requiredConstants.systemRoles}
            setIsViewOperators={setIsViewOperators}
            isViewOperators={isViewOperators}
          />
        </Box>
      </Box>
    </>
  );
}

export default Admin;
